var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeaderLogout = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.7812 10.5312C18.075 10.2375 18.075 9.7625 17.7812 9.47188L13.7812 5.46875C13.4875 5.175 13.0125 5.175 12.7219 5.46875C12.4313 5.7625 12.4281 6.2375 12.7219 6.52812L15.4406 9.24687L7.75 9.25C7.33437 9.25 7 9.58437 7 10C7 10.4156 7.33437 10.75 7.75 10.75H15.4406L12.7219 13.4688C12.4281 13.7625 12.4281 14.2375 12.7219 14.5281C13.0156 14.8187 13.4906 14.8219 13.7812 14.5281L17.7812 10.5312ZM7.25 4.5C7.66563 4.5 8 4.16562 8 3.75C8 3.33437 7.66563 3 7.25 3H4.75C3.23125 3 2 4.23125 2 5.75V14.25C2 15.7688 3.23125 17 4.75 17H7.25C7.66563 17 8 16.6656 8 16.25C8 15.8344 7.66563 15.5 7.25 15.5H4.75C4.05938 15.5 3.5 14.9406 3.5 14.25V5.75C3.5 5.05938 4.05938 4.5 4.75 4.5H7.25Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "8b0ba65f3310f9de53f03d39cea413ac.svg";